export default {
  load(gatewayType, src) {
    return new Promise(function(resolve, reject) {
      const id = `_tito-credit-card-script-${gatewayType}`;
      if (!document.getElementById(id)) {
        let script = document.createElement("script");
        script.id = id;
        script.src = src;
        script.onload = () => {
          resolve(gatewayType);
        };
        document.body.appendChild(script);
      }
    });
  }
};
